import { render, staticRenderFns } from "./monitorConfig.vue?vue&type=template&id=781724fb&scoped=true&"
import script from "./monitorConfig.vue?vue&type=script&lang=js&"
export * from "./monitorConfig.vue?vue&type=script&lang=js&"
import style0 from "./monitorConfig.vue?vue&type=style&index=0&id=781724fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781724fb",
  null
  
)

export default component.exports